import cn from 'classnames'
import IPath from 'interfaces/IPath'
import { FC, ReactNode } from 'react'

import MainLayout from 'layouts/MainLayout'

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Section from 'components/Section/Section'

import styles from './PageLayout.module.scss'

const PageHero = ({ title, subtitle, breadcrumbs, host }) => {
  return (
    <div className={styles.hero}>
      <Section backgroundClass={styles.Background}>
        <div className={styles.heroText}>
          {breadcrumbs?.length > 0 && <Breadcrumbs path={breadcrumbs} host={host} white />}
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </Section>
    </div>
  )
}

interface IPageLayout {
  title: string
  subtitle: string
  className?: string
  disablePaddings?: boolean
  children?: ReactNode
  breadcrumbs?: IPath[]
  host?: string
}
const PageLayout: FC<IPageLayout> = ({
  children,
  title,
  subtitle,
  className,
  disablePaddings = false,
  breadcrumbs,
  host,
}) => {
  return (
    <MainLayout>
      <PageHero subtitle={subtitle} title={title} breadcrumbs={breadcrumbs} host={host} />
      <Section
        withTopPadding={!disablePaddings}
        withBottomPadding={!disablePaddings}
        // withHorizontalPadding={!disablePaddings}
        backgroundClass={cn(styles.content, className)}
      >
        {children}
      </Section>
    </MainLayout>
  )
}

export default PageLayout
